module.exports = __webpack_public_path__ + "img/pos-img3.5db5dd10.png";